import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en/translation.json';
import ko from './locales/ko/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: en
      },
      ko: {
        translation: ko
      }
    }
  });

i18n.on('languageChanged', (lng) => {
  const simpleLng = lng.split('-')[0];
  if (lng !== simpleLng) {
    i18n.changeLanguage(simpleLng);
  }
});

export default i18n; 